import { createApp } from "vue";
import PaymentHistorySection from "./sections/Payments/PaymentHistorySection.vue";

createApp({
    components: {
        PaymentHistorySection
    }
}).mount(".payment-history-section");
